import { render, staticRenderFns } from "./FirstHomeYes.vue?vue&type=template&id=72a683f0&scoped=true&"
import script from "./FirstHomeYes.vue?vue&type=script&lang=js&"
export * from "./FirstHomeYes.vue?vue&type=script&lang=js&"
import style0 from "./FirstHomeYes.vue?vue&type=style&index=0&id=72a683f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a683f0",
  null
  
)

export default component.exports